import React from 'react';
import { BadgeLayer } from './view';

interface Props {
    children?: React.ReactNode;
}

export const AvatarBadge = ({ children }: Props) => <BadgeLayer aria-hidden="true">{children}</BadgeLayer>;
